'use client'

import { useEffect, useState } from 'react'

import { signInWithPopup } from 'firebase/auth'
import { useRouter } from 'next/navigation'
import { toast } from 'react-toastify'

// import queryString from 'query-string'
import { appleProvider, auth, googleProvider } from '@/config/firebase'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { useLoginAccountMutation } from '@/redux'
import { authActions } from '@/redux/reducers/auth/auth.reducer'
import { log } from '@/utils'
import { SignUpAction } from '@/utils/fetchHeader'
import { Users } from '@/redux/api/auth/auth.type'

const useAuth = () => {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const [loginAccount] = useLoginAccountMutation()
  const [loading, setLoading] = useState(false)
  const inviteCode = useAppSelector((state) => state.root.auth?.inviteCode)

  // const isPWA = () => {
  //   return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  // }
  // const isMobile: boolean = useIsMobile()

  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(authActions.setLoading(true));

  //   const unsub = onAuthStateChanged(auth, async (user) => {
  //     if (user) {
  //       await handleSignIn(await user.getIdToken());
  //     } else {
  //       setLoading(false);
  //       dispatch(authActions.setLoading(false));
  //     }
  //   });

  //   return () => unsub();
  // }, []);

  useEffect(() => {
    const isInAppBrowser = () => {
      const ua = navigator.userAgent || navigator.vendor
      return /instagram|fbav|line|twitter|telegram|messenger/i.test(ua)
    }
    if (isInAppBrowser()) {
      window.location.href = window.location.host + window.location.pathname
    }
  }, [])

  const signInWithGoogle = async () => {
    setLoading(true)
    dispatch(authActions.setLoading(true))
    try {
      // await signInWithRedirect(auth, googleProvider);
      const cred = await signInWithPopup(auth, googleProvider)

      await handleSignIn(await cred.user.getIdToken())
    } catch (error: any) {
      if (error.code === 'auth/popup-closed-by-user' || error.code === 'auth/popup-blocked') {
        const message =
          'The current browser does not support login. Please open the website in an external browser (Chrome, Safari, etc.).'
        toast.error(message)
        window.open(window.location.origin, '_blank')
        return
      }
      toast.error(`Sign In failed, please contact our customer support`)
      log('Error signing in with Google: ', error)
    } finally {
      setLoading(false)
      dispatch(authActions.setLoading(false))
    }
  }

  const signInWithApple = async () => {
    setLoading(true)
    dispatch(authActions.setLoading(true))
    try {
      // await signInWithRedirect(auth, appleProvider);
      const cred = await signInWithPopup(auth, appleProvider)
      await handleSignIn(await cred.user.getIdToken())
    } catch (error) {
      log('Error signing in with Apple: ', error)
      toast.error('Sign In failed, please contact our customer support')
    } finally {
      setLoading(false)
      dispatch(authActions.setLoading(false))
    }
  }

  const signInWithTelegram = async () => {
    return
    // try {
    //   // const telegramPayload: any = queryString.parse(window.location.hash)
    //   // const tgWebAppData: any = queryString.parse(telegramPayload.tgWebAppData)
    //   // const urlParams = new URLSearchParams(window.location.search)
    //   // const botName = urlParams.get('tgWebAppStartParam')
    //
    //   // if (!tgWebAppData?.user) {
    //   //   return
    //   // }
    //
    //   setLoading(true)
    //   dispatch(authActions.setLoading(true))
    //   // let urlParams = new URLSearchParams(window.location.search);
    //
    //   // const authData = await axios.post(`${process.env.w3Url}/auth/oauth/telegram`, { tgWebAppData });
    //
    //   // const cred = await signInWithCustomToken(auth, authData.data.accessToken);
    //   //
    //   // await handleSignIn(await cred.user.getIdToken(), true);
    //   setLoading(true)
    //   dispatch(authActions.setLoading(true))
    //   // let urlParams = new URLSearchParams(window.location.search);
    //
    //   // const authData = await axios.post(`${process.env.w3Url}/auth/oauth/telegram`, {
    //   //   tgWebAppData,
    //   //   bot: botName,
    //   // })
    //
    //   // const cred = await signInWithCustomToken(auth, authData.data.accessToken)
    //
    //   // await handleSignIn(await cred.user.getIdToken(), true)
    // } catch (error) {
    //   log('Error signing in with Telegram: ', error)
    //   toast.error('Sign In failed, please contact our customer support')
    // } finally {
    //   setLoading(false)
    //   dispatch(authActions.setLoading(false))
    // }
  }

  const handleSignIn = async (token: string) => {
    setLoading(true)
    dispatch(authActions.setLoading(true))
    try {
      dispatch(authActions.setToken(token))

      const response = await loginAccount('').unwrap()
      dispatch(authActions.setIdUser(response?.payload?.id))
      dispatch(authActions.setUser(response.payload))
      if (response?.payload?.isActive === false) {
        router.push(inviteCode ? `/create-profile?inviteCode=${inviteCode}` : '/create-profile')
        return
      } else {
        dispatch(authActions.setUser(response?.payload))
        await SignUpAction(token, response.payload as unknown as Users)
        log('User signed in: ', response?.payload)
      }
      const currentPath = localStorage.getItem('current-path')
      router.push(currentPath || '/')

      // if (isMobile && !isPwaMode) {
      //     log('Mobile and not in PWA mode');
      //     router.replace(PATHS.ADDTOHOMESCREEN);
      // } else {
      //     // const messaging = getMessaging(firebase_app);
      //     dispatch(authActions.setToken(token));
      //     // const deviceToken = await getToken(messaging, { vapidKey: process.env.firebaseVapidKey });

      //     const response = await loginAccount('').unwrap();

      //     if (response?.payload?.isActive === false) {
      //         router.replace(PATHS.INVITECODE);
      //     } else if (!response?.payload?.walletAddress) {
      //         router.replace(PATHS.CREATECONFIRMPASS);
      //     } else {
      //         dispatch(authActions.setUser(response?.payload));
      //         await SignUpAction(token, response.payload);
      //         router.replace(PATHS.FEED);
      //         log('User signed in: ', response?.payload);
      //     }
      // }
    } catch (e) {
      log('Error signing in: ', e)
      toast.error(`Sign In failed, please contact our customer support, ${JSON.stringify(e)}`)
    } finally {
      dispatch(authActions.setLoading(false))
      setLoading(false)
    }
  }

  return {
    signInWithGoogle,
    signInWithApple,
    signInWithTelegram,
    loading,
    handleSignIn,
  }
}

export default useAuth
